import { render, staticRenderFns } from "./edit_seminar.vue?vue&type=template&id=142de5de"
import script from "./edit_seminar.vue?vue&type=script&lang=js"
export * from "./edit_seminar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports